import React from "react";
import './General.css'
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";

const SafetySecurity = () => {
  return (
    <div className="General-page">
      <div className="General-section">
        <h1>Safety & Security</h1>
        <div>
          <div>
            <Accordion
              defaultActiveKey="0"
              flush
              className="General-background"
            >
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    What are the risks involved in the investment Platform?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  In OVest, your investment is guaranteed because we have
                  adequate risk management with major national and international
                  brokerage firms.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div>
            <Accordion
              defaultActiveKey="0"
              flush
              className="General-background-one"
            >
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    Is my money secured with OVest?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  Yes, your funds are always secured. No matter what, you won't
                  lose your capital because we always have an equivalent amount
                  of assets as the capital used in the business of Forex Trading
                  and other investment opportunities offered by the industry (in
                  case of a rainy day). We also guarantee the safety of your
                  funds further by signing a memorandum of understanding with
                  you, stating clearly that your capital will be refunded if
                  anything changes.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetySecurity;
